import {DocumentStatus} from '../../../api';
import {
    useEditModeDocsInfiniteQueryCache,
    useEditModeDocsInfiniteQuery,
    MetadataFilter
} from '../../../hooks/use-edit-mode-docs-infinite-query';

interface Props {
    searchText?: string;
    categoryId?: string;
    metadata: MetadataFilter[];
    onlyUserDocuments?: boolean;
    pageSize: number;
}

export function useSearchDocsQuery(props: Props) {
    return useEditModeDocsInfiniteQuery({
        queryKey: 'search',
        searchText: props.searchText,
        statuses: [DocumentStatus.DRAFT, DocumentStatus.EDITABLE, DocumentStatus.PUBLISHED],
        metadata: props.metadata,
        onlyUserDocuments: props.onlyUserDocuments,
        pageSize: props.pageSize,
        categories: props.categoryId ? [props.categoryId] : undefined,
        options: {
            enabled: !!props.searchText || !!props.categoryId || !!props.metadata.length
        }
    });
}

export function useSearchDocsCache() {
    return useEditModeDocsInfiniteQueryCache('search');
}
